module.exports = {
	"apertureWidth": "Aperture Width",
	"apertureLength": "Aperture Length",
	"apertureGap1": "Aperture Gap 1",
	"apertureGap2": "Aperture Gap 2",
	"ballDiameter": "Ball Diameter",
	"bodyOffset": "Body Offset",
	"bodyLength": "Body Length",
	"bodyDiameter": "Body Diameter",
	"bodyHeight": "Body Height",
	"bodyColor": "Body Color",
	"componentFamily": "Component Family",
	"colPitch": "Col Pitch",
	"chipArrayNote": "* L1 and b1 are optional.",
	"crystalNote": "* Select optional dimension from (D, D2, L). Different combinations may produce different footprint pad sizes.",	
	"densityLevel": "Density Level",	
	"femaleStandoffNote": "* Mounting hole pad is optional and can be generated by entering values for dimensions shown in the left image. Hole diameter (b) is used for mounting hole generation and for spacer mechanical model without internal threading.",
	"footprintOrigin": "Footprint Origin",
	"hPinPitch": "Horizontal Pin Pitch",
	"hTerminalGap": "Horizontal Terminal Gap",
	"hTerminalTailLength": "Horizontal Terminal Tail Length",
	"innerThreadDepth": "Inner Thread Depth",
	"innerThreadSize": "Inner Thread Size",
	"innerThreadDesignation": "Inner Thread Designation",
	"leadDiameter": "Lead Diameter",
	"leadSpan": "Lead Span",
	"leadSpan1": "Lead Span 1",
	"leadSpan2": "Lead Span 2",
	"leadShape": "Lead Shape",
	"largerTerminalLength": "Larger Terminal Length",
	"largerTerminalWidth": "Larger Terminal Width",
	"maleFemaleStandoffNote": "* Mounting hole pad is optional and can be generated by entering values for dimensions shown in the left image. Hole diameter (b) is used for mounting hole generation.",
	"mapSilkscreen": "Map Silkscreen to Body",
	"optionalDimensionNote": "* Select optional dimension from (D, D2, L). Different combinations may produce different footprint pad sizes.",
	"oddTerminalLength": "Odd Terminal Length",
	"oddTerminalWidth": "Odd Terminal Width",
	"optionalDimension": "Optional Dimension",	
	"partialThread": "Partial Thread",	
	"pasteCoverage": "Paste Coverage",
	"producibilityLevel": "Producibility Level",
	"pinPitch": "Pin Pitch",
	"padToHoleRatio": "Pad to Hole Ratio",
	"padRoundness": "Pad Roundness",
	"pinNumbering": "Pin Numbering",
	"postLength": "Post Length",
	"postThreadSize": "Post Thread Size",
	"postThreadDesignation": "Post Thread Designation",
	"rowPitch": "Row Pitch",
	"tabWidth": "Tab Width",
	"tabLength": "Tab Length",
	"terminalThickness": "Terminal Thickness",
	"terminalWidth": "Terminal Width",
	"terminalLength": "Terminal Length",
	"terminalGap": "Terminal Gap",
	"terminalCCGap": "Terminal Center-Center Gap",
	"terminalCCGap1": "Terminal Center-Center Gap 1",
	"terminalCCGap2": "Terminal Center-Center Gap 2",
	"terminalTailLength": "Terminal Tail Length",
	"terminalPostLength": "Terminal Post Length",
	"terminalType": "Terminal Type",	
	"threadDepth": "Thread Depth",
	"threadSize": "Thread Size",
	"threadDesignation": "Thread Designation",	
	"threaded": "Threaded",
	"truncateMiddlePin": "Truncate Middle Pin",		
	"vPinPitch": "Vertical Pin Pitch",
	"vTerminalGap": "Vertical Terminal Gap",
	"vTerminalTailLength": "Vertical Terminal Tail Length",
	"#Rows": "# Rows",
	"#Cols": "# Cols",
	"#Pins": "# Pins",
	"#DPins": "# Pins (D Side)",
	"#EPins": "# Pins (E side)",
	"padShape": "Pad Shape",
	"RESISTOR": "Resistor",
	"NONPOLARIZED_CAPACITOR": "Capacitor - Non polarized",
	"POLARIZED_CAPACITOR": "Polarized Capacitor",
	"DIODE": "Diode",
	"FUSE": "Fuse",
	"INDUCTOR": "Inductor",
	"POLARIZED_INDUCTOR": "Polarized Inductor",
	"NONPOLARIZED_INDUCTOR": "Inductor - Non polarized",
	"LRCCW": "Counter-clockwise from bottom left",
	"LRCW": "Clockwise from top left",
	"ZZBT": "ZigZag from bottom left",
	"PIN_ONE": "Pin 1",
	"CENTER_PADS": "Center of pads",
	"female": "Female",
	"male": "Male",
	"maleFemale": "Male-Female",
	"ROUND": "Round",
	"HEX": "Hex",
	"SQUARE": "Square",
	"Round": "Round",
	"Square": "Square",
	"RoundedSquare": "Rounded Square",
	"Rectangle": "Rectangle",
	"Black": "Black",
	"Green": "Green",
	"Blue": "Blue",
	"Yellow": "Yellow",
	"Amber": "Amber",
	"Brown": "Brown",
	"Cyan": "Cyan",
	"Maroon": "Maroon",
	"Grey": "Grey",
	"Silver": "Silver",
	"Purple": "Purple",
	"Red": "Red",
	"White": "White",
	"Most (A)": "Most (A)",
	"Nominal (B)": "Nominal (B)",
	"Least (C)": "Least (C)",
	"Most (M)": "Most (M)",
	"Nominal (N)": "Nominal (N)",
	"Least (L)": "Least (L)",
	"IC": "Integrated Circuit (IC)",
	"PRECISION_INDUCTOR": "Precision Inductor",
	"LED": "LED",
	"THERMISTOR": "Thermistor",
	"POLARIZED_DIODE": "Diode",
	"VARISTOR": "Varistor",
	"FERRITE_BEAD": "Ferrite Bead",
	"SOIC_SOP": "SOIC, SOP",
	"QFP": "QFP",
	"CFP": "CFP",
	"CQFP": "CQFP",
	"QFN": "QFN",
	"SOT23": "SOT23",
	"SOTFL": "SOTFL",
	"SOT223": "SOT223",
	"TO_DPAK": "TO, DPAK",
	"SOT143": "SOT143",
	"CHIP": "Chip",
	"SOD": "SOD",
	"MOLDED_BODY": "Molded Body",
	"SODFL": "SODFL",
	"DFN_2": "DFN-2",
	"DFN_3": "DFN-3",
	"DFN_4": "DFN-4",
	"ECAP": "E-Cap",
	"CRYSTAL": "Crystal",
	"BGA": "BGA",
	"MELF": "MELF",
	"CHIP_ARRAY_TWO_SIDE_FLAT_CONCAVE": "Chip Array, 2 Side Flat/Concave",
	"CHIP_ARRAY_FOUR_SIDE_FLAT_CONCAVE": "Chip Array, 4 Side Flat/Concave",
	"CHIP_ARRAY_TWO_SIDE_CONVEX": "Chip Array, 2 Side Convex",
	"PLCC": "PLCC",
	"OSCILLATOR_CORNER_CONCAVE": "Oscillator Corner Concave",
	"OSCILLATOR_J_LEAD": "Oscillator J-Lead",
	"OSCILLATOR_L_BEND": "Oscillator L-Bend",
	"SOJ": "SOJ",
	"AXIAL": "Axial",
	"DIP": "DIP",
	"PIN_HEADER_STRAIGHT": "Pin Header (Male) Straight",
	"PIN_HEADER_RA": "Pin Header (Male) Right Angle",
	"RECEPTACLE_HEADER_STRAIGHT": "Receptacle Header (Female) Straight",
	"RECEPTACLE_HEADER_RA": "Receptacle Header (Female) Right Angle",
	"SON_DFN": "SON (DFN)",
	"RADIAL_GENERIC": "Radial Generic (Round)",
	"RADIAL_LED": "Radial LED (Round)",
	"CRYSTAL_HC49": "Crystal (HC49)",
	"FEMALE_STANDOFF": "Female Standoff/Spacer",
	"MALE_FEMALE_STANDOFF": "Male-Female Standoff",
	"SNAP_LOCK": "Snap Lock",
	"Optional_D": "D (Lead Span)",
	"Optional_D2": "D2 (Terminal Gap)",
	"Optional_L": "L (Terminal Length)",
	"CONCAVE": "Concave",
	"FLAT": "Flat",
	"Oblong": "Oblong",
	"Collapsing_Ball": "Collapsing Ball",
	"Non_Collapsing_Ball": "Non Collapsing Ball",
	"mountingHolePad": "Mounting Hole Pad",
	"withVias": "With Vias",
	"viasCount": "Vias Count",
	"viaDiameter": "Via Diameter",
	"viaOffset": "Via Offset From Hole Center",
	"viaThermalRelief": "Via Thermal Relief'",
	"radialLedNote": "* c is not applicable for rounded lead shape.",
	"lockHeight": "Lock Height",
	"overrideLockDiameter": "Override Lock Diameter",
	"lockDiameter": "Lock Diameter",
	"overridePitch": "Override Pin Pitch",
	"bodyWidth": "Body Width",
	"padWidth": "Pad Width",
	"plated": "Plated",
	"ViaOffset": "Via Offset From Hole Center",
	"holeDiameter": "Hole Diameter",
	"snapLockNote1": "* Lock diameter (E1) is automatically calculated based on the body diameter (E) and hole diameter (b). However you can provide custom value by overriding the lock diameter.",
	"snapLockNote2": "* Hole diameter (b) should not be equal to the body diameter (E) and lock diameter(E1)",
	"leadWidth": "Lead Width",
	"leadThickness": "Lead Thickness",
	"boardThickness": "Board Thickness",
	"error1": "Not implemented.",
	"fabricationTolerance": "Fabrication Tolerance", 
	"placementTolerance": "Placement Tolerance",
	"CAPACITOR": "Capacitor - Non polarized",
	"CAPACITOR_NONPOLARIZED": "Capacitor - Non polarized",
	"CAPACITOR_NON_POLARIZED": "Capacitor - Non polarized",
	"FILTER": "Filter", 
	"TRANSISTOR": "Transistor",
	"ecapNote": "* Select optional dimension from (D, D2, L). Different combinations may produce different footprint pad sizes.",
	"maximum": "Maximum", 
	"nominal": "Nominal", 
	"minimum": "Minimum",
	"bodyShape": "Body Shape",
	"customSolderPaste": "Custom Solder Paste",
	"thermalPad": "Thermal Pad",
	"thermalPadLength": "Thermal Pad Length",
	"thermalPadWidth": "Thermal Pad Width",
	"RoundedRectangle": "Rounded Rectangle",
	"extendedEdgeLength": "Extended Edge Length",
	"Generator": " Generator",
	"axialNote": "* Pin pitch is automatically calculated based on the size of body, terminal and producibility level to make the footprint IPC compliant.  However you can provide custom value by overriding pin pitch to create non IPC compliant footprint.",
	"baseHeight": "Base Height",
	"CHIP_LED": "Chip LED",
	"updatePreview": "Update Preview",
	"Custom": "Custom",
	"ledColorNote": "* Enter value in Hex for custom body color.",
	"customBodyColor": "Custom Body Color",							
	"lensShape": "Lens Shape",
	"domeDiameter": "Dome Diameter",
	"RECT_FLAT_TOP": "Rectangle with Flat Top",
	"RECT_DOMED_TOP": "Rectangle with Domed Top",
	'customFootprint': 'Custom Footprint',
	'customPadLength': 'Custom Pad Length',
	'customPadWidth': 'Custom Pad Width',
	'customPadGap': 'Custom Pad To Pad Gap',
	'customOddPadWidth': 'Custom Odd Pad Width',
	'customOddPadLength': 'Custom Odd Pad Length',
	'customPadDiameter': 'Custom Pad Diameter',
	'customPadSpan1': 'Custom Pad Span 1',
	'customPadSpan2' : 'Custom Pad Span 2',
	'customPadPitch' : 'Custom Pad Pitch',
	'pinPitch1' : 'Pin Pitch 1',
	'customPadGap1': 'Custom Pad To Pad Gap 1',
	'Optional_g': 'g (Custom Pad Gap)',
	'Optional_p': 'p (Custom Pad Pitch)',

	// JS Widgets
	"New_Library": "New Library",
	"Components": "Components",
	"Component": "Component",
	"Symbols": "Symbols",
	"Symbol": "Symbol",
	"Footprints": "Footprints",
	"Footprint": "Footprint",
	"Packages": "Packages",
	"Package": "Package",
	"No": "No",
	"Name": "Name",
	"Pins": "Pins",
	"Pads": "Pads",
	"Description": "Description",
	"Variants": "Variants",
	"Type": "Type",
	"Hub_URN": "Hub URN",
	"Hub_Version": "Hub Version",
	"Library_io_URN": "Library.io URN",
	"Library_io_Version": "Library.io Version",
	"Link": "Link",
	"Rename": 'Rename',
	"Edit_Description": 'Edit Description',
	"Duplicate": 'Duplicate', // verb, not noun.  ie "Make a copy"
	"Create_New_3D_Model": 'Create New 3D Model',
	"Attach_Copy_Existing_3D_Model": 'Attach Copy of Existing 3D Model',
	"Edit": 'Edit',
	"Delete": 'Delete',
	"Remove_From": 'Remove from',
	"Update_To_Latest": 'Update to Latest',
	"Create_New_Symbol": 'Create New Symbol',
	"Create_New_Footprint": 'Create New Footprint',
	"Create_New_Component": 'Create New Component',
	"Create_New_Package": 'Create New Package',
	"Delete_Package_Children_Warning": "This will also delete the packages used by this footprint.",
	"No_Search_Results": "No Search Results",
	"No_Library_Loaded": "Library Not Loaded",
	"Library_Stored_Fusion_Hub": "This library is stored in your Fusion Hub.",
	"Library_Linked_Managed_Library": "This library is linked to a Library.io Managed Library.",
	"Library_Local_Changes": "This library has changes that have not been pushed to Library.io.  To do this, go to the 'Manage' toolbar.",
	"Library_Remote_Changes": "This library has new updates that can be pulled from Library.io.  To do this, go to the 'Manage' toolbar.",
	"View_on_Library_io": "View on Library.io",
	"Used_In": "Used In",
	"No_Selection": "No Selection",

	"No_Footprints": "No Footprints",
	"No_Symbols": "No Symbols",
	"No_Components": "No Components",
	"No_Packages": "No Packages",

	"Package_Loading_Message": "Please wait while the package is saved and uploaded.",
	"Attributes": "Attributes",
	"View_Attributes": "View Attributes",
	"Edit_Attributes": "View Attributes",
	"Edit_Description": "Edit Description",
	
	"Use_Placeholder": "Use Placeholder",
	"Placeholder_Message": "Use a placeholder shape when no 3D model is associated with the footprint.",

	"Hub": "Hub",
	"New_Symbol": 'New Symbol',
	"New_Footprint": 'New Footprint',
	"New_Component": 'New Component',
	"New_Package": 'New Package',

	"Asset_Ahead":  "Local changes are detected.  To publish these changes to Library.io, use the 'Manage' toolbar.",
	"Package_Behind_Lio": "Library.io package update is available.  Right click and select Update.",
	"Package_Behind_Fusion": "Fusion package update is available.  Right click and select Update.",
	"Package_Behind_Both": "A package update is available.  Right click and select Update.",
	"Package_On_Lio":  "This package exists only on Library.io.  Editing it will create a linked model in your Fusion Hub.",
	"Package_Behind_Blocked": "The library must be updated before asset changes can be pulled.  To update the library, use the 'Manage' toolbar.",
}